import { Dispatch } from '@reduxjs/toolkit'
import { setShowSpinner } from '../slices/spinner.slice'

export const showSpinner =
    (requestPayload: boolean) =>
    (dispatch: Dispatch): void => {
        dispatch(setShowSpinner(requestPayload))
    }
